import { resolveLocale } from '../i18n/locale';

const ERROR_MESSAGES = {
  api_request_failed: {
    ko: '요청을 처리하지 못했습니다. 잠시 후 다시 시도해 주세요.',
    en: 'The request could not be completed. Please try again shortly.',
  },
  auth_required: {
    ko: '로그인이 필요합니다.',
    en: 'Login is required.',
  },
  session_expired: {
    ko: '세션이 만료되었습니다. 다시 로그인해 주세요.',
    en: 'Your session has expired. Please log in again.',
  },
  chemistry_login_required: {
    ko: '궁합 분석은 로그인 후 1회 무료로 이용할 수 있습니다.',
    en: 'Log in to use your first free chemistry analysis.',
  },
  chemistry_payment_required: {
    ko: '무료 궁합 분석 1회를 모두 사용했습니다. 추가 분석은 결제가 필요합니다.',
    en: 'Your free chemistry analysis has been used. Purchase a pass for another analysis.',
  },
  chemistry_low_confidence: {
    ko: '얼굴 인식 신뢰도가 낮습니다. 밝은 곳에서 정면 사진으로 다시 시도해 주세요.',
    en: 'Face detection confidence was low. Try again with bright, front-facing photos.',
  },
  face_a_not_detected: {
    ko: '첫 번째 사진에서 얼굴을 인식하지 못했습니다. 다른 사진을 선택해 주세요.',
    en: 'No face was detected in the first photo. Please choose another photo.',
  },
  face_b_not_detected: {
    ko: '두 번째 사진에서 얼굴을 인식하지 못했습니다. 다른 사진을 선택해 주세요.',
    en: 'No face was detected in the second photo. Please choose another photo.',
  },
  chemistry_analysis_failed: {
    ko: '궁합 분석에 실패했습니다. 사진을 확인하고 다시 시도해 주세요.',
    en: 'Chemistry analysis failed. Check the photos and try again.',
  },
  chemistry_internal_error: {
    ko: '서버에서 궁합 분석을 완료하지 못했습니다. 잠시 후 다시 시도해 주세요.',
    en: 'The server could not complete the chemistry analysis. Please try again shortly.',
  },
  upload_too_large: {
    ko: '이미지 용량이 너무 큽니다. 더 작은 사진을 선택해 주세요.',
    en: 'The image is too large. Please select a smaller photo.',
  },
  file_too_large: {
    ko: '사진 용량이 너무 큽니다. 50MB 이하의 사진을 선택해 주세요.',
    en: 'The photo is too large. Please select a photo under 50 MB.',
  },
  processed_file_too_large: {
    ko: '사진을 업로드 가능한 크기로 줄이지 못했습니다. 더 작은 사진을 선택해 주세요.',
    en: 'The photo could not be reduced to an uploadable size. Please select a smaller photo.',
  },
  image_decode_failed: {
    ko: '이 사진 형식을 변환하지 못했습니다. JPEG·PNG 사진을 선택하거나 카메라로 다시 촬영해 주세요.',
    en: 'This photo format could not be converted. Select a JPEG or PNG, or take a new photo.',
  },
  empty_image: {
    ko: '사진 데이터를 읽지 못했습니다. 사진을 다시 선택해 주세요.',
    en: 'The photo data could not be read. Please select the photo again.',
  },
  face_not_detected: {
    ko: '사진에서 얼굴을 인식하지 못했습니다. 밝은 곳에서 촬영한 정면 얼굴 사진으로 다시 시도해 주세요.',
    en: 'No face was detected. Try again with a bright, front-facing face photo.',
  },
  unsupported_image_format: {
    ko: '지원하지 않거나 손상된 사진입니다. JPEG·PNG 사진으로 다시 시도해 주세요.',
    en: 'This photo is unsupported or damaged. Try again with a JPEG or PNG photo.',
  },
  analysis_timeout: {
    ko: '분석 시간이 초과되었습니다. 네트워크와 이미지 용량을 확인해 주세요.',
    en: 'Analysis timed out. Check your network and image size.',
  },
  analysis_internal_error: {
    ko: '분석 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.',
    en: 'An error occurred during analysis. Please try again shortly.',
  },
  permission_denied: {
    ko: '이 작업을 수행할 권한이 없습니다.',
    en: 'You do not have permission to perform this action.',
  },
  payment_failed: {
    ko: '결제를 처리하지 못했습니다. 결제 정보를 확인하고 다시 시도해 주세요.',
    en: 'Payment could not be processed. Check the payment details and try again.',
  },
  result_not_found: {
    ko: '요청한 결과를 찾을 수 없습니다.',
    en: 'The requested result could not be found.',
  },
  result_error: {
    ko: '결과를 처리하지 못했습니다. 다시 시도해 주세요.',
    en: 'The result could not be processed. Please try again.',
  },
  face_analysis_error: {
    ko: '얼굴 분석 요청을 처리하지 못했습니다.',
    en: 'The face analysis request could not be processed.',
  },
  harmony_error: {
    ko: '궁합 요청을 처리하지 못했습니다.',
    en: 'The harmony request could not be processed.',
  },
  auth_error: {
    ko: '인증 요청을 처리하지 못했습니다. 다시 로그인해 주세요.',
    en: 'Authentication could not be completed. Please log in again.',
  },
  not_found: {
    ko: '요청한 항목을 찾을 수 없습니다.',
    en: 'The requested item could not be found.',
  },
  server_error: {
    ko: '서버 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.',
    en: 'A server error occurred. Please try again shortly.',
  },
  invalid_request: {
    ko: '요청 내용을 확인하고 다시 시도해 주세요.',
    en: 'Check the request and try again.',
  },
};

export class ApiError extends Error {
  constructor(code, status, fallbackMessage = '') {
    super(fallbackMessage || code || 'api_request_failed');
    this.name = 'ApiError';
    this.code = code || 'api_request_failed';
    this.status = status;
    this.fallbackMessage = fallbackMessage;
  }
}

export function getLocalizedError(errorOrCode, language) {
  const code = typeof errorOrCode === 'string'
    ? errorOrCode
    : errorOrCode?.code || 'api_request_failed';
  const locale = resolveLocale(language);
  return ERROR_MESSAGES[code]?.[locale] || ERROR_MESSAGES.api_request_failed[locale];
}
